import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const membershipSurveyChoice: AnswerPathTreeNode = {
  path: 'membership-survey-choice',
  nodeId: NodeIds.membershipSurveyChoice,
};
